import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// Shape of the error body returned by the BusMan API.
interface ApiErrorBody {
  success: boolean;
  errors: string;
}

const isApiErrorBody = (data: unknown): data is ApiErrorBody =>
  typeof data === 'object' &&
  data !== null &&
  'errors' in data &&
  typeof (data as Record<string, unknown>).errors === 'string';

/**
 * Extracts a human-readable message from an RTK Query error.
 *
 * Handles the full FetchBaseQueryError union:
 * - FETCH_ERROR / TIMEOUT_ERROR / PARSING_ERROR / CUSTOM_ERROR carry an `error` string.
 * - HTTP errors carry `data: unknown`, which we narrow to the BusMan `{ errors }` body.
 */
export const getApiErrorMessage = (response: FetchBaseQueryError): string => {
  if ('error' in response) {
    return response.error;
  }

  if (isApiErrorBody(response.data)) {
    return response.data.errors;
  }

  return `Request failed with status ${response.status}`;
};
